import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import useImageSize from "../../../../hooks/global/useImageSize";
import { ListingCardMedia } from "./ListingCardMedia";

export const ListingCoverImage = () => {
  const trainingPlanRedux = useSelector((state: RootState) => {
    return state.trainingPlan.listingData;
  });
  const [resizedImage] = useImageSize({
    originalFormat: true,
    isCover: true,
    imageUrl: trainingPlanRedux?.coverImage,
    size: 1000,
  });
  return <ListingCardMedia resizedImage={resizedImage} />;
};
